import React, { useState, useRef, memo } from 'react';
import styled from 'styled-components';
import { useDriversStore } from '../hos-context';
const DriverNamesContainer = styled.div`
    width:100%;
    height:100%;
    box-sizing: border-box;
    padding: 0 0.5rem 0 0.5rem;
    position: relative;
    ${props => props.$open ? 'z-index: 30;' : ''}
`;
/** Clip lives inside the padded content box so text crops before the right inset. */
const DriverNamesClip = styled.div`
    width:100%;
    height:100%;
    overflow: hidden;
`;
const StaticDriverNamesView = styled.div`
    display:flex;
    align-items:center;
    height:100%;
    cursor:pointer;
    &>div{
        white-space: nowrap;
        .secondDriver{
            margin-top:0.5rem;
        }
    }
`
const DriverNameWrapper = styled.div`
    position:absolute;
    z-index: 30;
    left: 0;
    top: 0;
    width: max-content;
    min-height: 4rem;
    background-color:var(--bg);
    border-radius:0.5rem;
    box-shadow: var(--on-hover-visible-object-shadow);
    .changeOnHoverContent{
        width: max-content;
        position:relative;
        white-space: nowrap;
        z-index:6;
        padding:1.5rem;
        .secondDriver{
            margin-top:1rem;
        }
        &>div{
            display:flex;
            .expandContent{
                overflow:visible;
                white-space: pre;
                display:flex;
            }
        }
    }
`
// const DriverHoursWidgetBox = styled.div`
//     height:100%;
//     display:flex;
//     align-items:center;
//     margin-left:0.5rem;
//     &>svg{
//         color:var(--light-gray);
//     }
//     .tooltip{
//         font-weight:500;
//         line-height:1.5rem;
//     }
//     :hover{
//         .tooltip{
//             visibility: visible;
//             transition-property: visibility;
//             transition-delay: 0.7s;
//         }
//     }
// `

const DriverCurrentStatusLbl = styled.div`
    font-size:0.75rem;
    margin-right:0.5rem;
    padding:0.2rem;
    border-radius:0.4rem;
    background-color:${props=>props.$colorcode ? `rgba(${props.$colorcode}, 0.2)` : "var(--extra-light-gray)"};
    color:${props=>props.$colorcode ? `rgba(${props.$colorcode}, 1)`  : "var(--light-gray)"};
`
export const MB_DRIVER_NAMES = memo(({trucksSetDataMethodsObject, driver1, driver2, popupViewManagingObject, hiddenField}) => { 
    const [open, setOpen] = useState(false);
    const container = useRef(null);
    const id = `${driver1 ? driver1.id : "id"}&${driver2 ? driver2.id : "id"}`;
    return <DriverNamesContainer className="standard_text driver-names" ref={container} $open={open} >
       {open ?
            <DriverNameWrapper id="currentlyExpandedDriver" >
                <div className="changeOnHoverContent" >
                    <DriverNameView driver={driver1}  />
                    <DriverNameView className={driver1?'secondDriver':null} driver={driver2} />
                </div>
            </DriverNameWrapper>
            :
            <DriverNamesClip>
                <StaticDriverNamesView onClick={(e)=>{
                    e.stopPropagation();
                    popupViewManagingObject(id, container, setOpen);
                    setOpen(true);
                }}>
                    <div>   
                        <StaticDriverNames driver={driver1} />
                        <StaticDriverNames className={driver1?'secondDriver':null} driver={driver2} />
                    </div>
                </StaticDriverNamesView>
            </DriverNamesClip>
        }
    </DriverNamesContainer>
})

const StaticDriverNames = ({className, driver}) => {
    if(!driver)return null;
    return <div className={className?className:""}>
        {`${driver.firstName} ${driver.lastName}`}
    </div>
}
const DriverNameView = ({className, driver}) =>{
    const hosData = useDriversStore(s => s.byId[driver ? driver.trackingId : ""]);
    if(!driver)return null;
    const hosObject = statusToLabelObject(hosData ? hosData.hosStatus : null) ;
    return <div className={`${className?className:""} driverNameHoldingContainer`}>
        {hosObject ? 
            <div className="expandContent">
                <DriverCurrentStatusLbl $colorcode={hosObject.colorcode}>
                    {hosObject.lbl}
                </DriverCurrentStatusLbl>
            </div>
            :
            null
        }
        {`${driver.firstName}`}
        {driver.middleName?
            <><div className="expandContent">
                {` ${driver.middleName}, `}
            </div></>
            :` `}
        {` ${driver.lastName}`}
        <div className="expandContent">
            {` - ${driver.phoneNumber}`}
            {/* {driver.hos ?  <DriverHoursViewer hos={driver.hos} /> : null} */}
        </div>
    </div>
}
export const statusToLabelObject = (currentStatus) =>{
    if(!currentStatus)return null;
    // hosStatusTypes : "offDuty", "sleeperBed", "driving", "onDuty", "yardMove", "personalConveyance"
    // offD SP, DR, onD, YM, PC
    switch (currentStatus) {
        case "offDuty":
            return {lbl:"offD"};             
        case "sleeperBed":
            return {lbl:"SB", colorcode:"var(--inProgressYellowRGB)"};   
        case "driving":
            return {lbl:"DR", colorcode:"var(--successGreenRGB)"};       
        case "onDuty":
            return {lbl:"onD", colorcode:"var(--inProgressGreenRGB)"};  
        case "yardMove":
            return {lbl:"YM"};
        case "personalConveyance":
            return {lbl:"PC", colorcode:"var(--inProgressPurpleRGB)"};
        default:
            return {lbl:"--"};
    }
}
// const cursorToLabel = (cursor) => {
//     switch (cursor) {
//         case "cycleRemaining":
//             return "Cycle Remaining";
//         case "driveRemaining":
//             return "Drive Remaining";
//         case "shiftRemaining":
//             return "Shift Remaining";
//         case "timeUntilBreak":
//             return "Time Until Break";
//         case "cycleTomorrow":
//             return "Cycle Tomorrow";
//         default:
//             return "";
//     }
// }
// const DriverHoursViewer = ({hos}) =>{
    
//     let detailedHos = ``;
//     for(const key of Object.keys(hos)){
//         detailedHos += `${cursorToLabel(key)}: ${hos[key]}\n`
//     }
//     return <DriverHoursWidgetBox>
//         <LuClock2 />
//         <CustomTooltip info={detailedHos} marginTop={"1.3rem"} xDisposition="-2rem" />
//     </DriverHoursWidgetBox>
    
// }


// {
//     "driver": {
//       "id": "45982711",
//       "name": "QARSHAYE, MUSTAF HASSAN"
//     },
//     "currentVehicle": {
//       "id": "281474990181639",
//       "name": "231981"
//     },
//     "currentDutyStatus": {
//       "hosStatusType": "driving"
//     },
//     "violations": {
//       "shiftDrivingViolationDurationMs": 0,
//       "cycleViolationDurationMs": 0
//     },
//     "clocks": {
//       "break": {
//         "timeUntilBreakDurationMs": 28069185
//       },
//       "drive": {
//         "driveRemainingDurationMs": 38869185
//       },
//       "shift": {
//         "shiftRemainingDurationMs": 48002075
//       },
//       "cycle": {
//         "cycleStartedAtTime": "2024-10-21T09:59:11.000Z",
//         "cycleRemainingDurationMs": 249905185,
//         "cycleTomorrowDurationMs": 249905185
//       }
//     }
//   }

